import ModelData from '../../../public/model_data';
import ModuleManager from '../../../../framework/core/module_manager';
import NetPrompt from '../../../public/module/netprompt/netprompt';
import ServerBase from '../server_base';
import { ProtoHallServerNotify } from './proto_hall_gameserver_notify';
import { NetMsgDataMapHallNotify } from './net_msg_data_map_hall_notify';
import AppData from '../../../public/const/app_data';
import { GameManager } from '../../../../manager/game_manager';




const { ccclass } = cc._decorator;


@ccclass
export default class HallServerNotify extends ServerBase {

    _maxReconTimes = 3
    public static instance: HallServerNotify;    

    onNotifyLogin: (data: ProtoHallServerNotify.ILoginRsp,reconnect : boolean) => void;
    onEnterGameHall: (data: ProtoHallServerNotify.IEnterGameHallRsp) => void;
    onNotifyHallData: (data: ProtoHallServerNotify.INotifyHallData) => void;
    onNotifyRoomTypeData:(data:ProtoHallServerNotify.INotifyRoomTypeData) =>void;
    

    onLoad() {
        HallServerNotify.instance = this
        this.init("HallServerNotify")
    }

    connectServer() {
        
        this.connect(  GameManager.hallServer +  ModelData.instance.password + "")
    }

    protected onConnected() {        
        this.loginServer()
    }

    loginServer() {
        let self = this


        self.model.subscibeMsgEvent<ProtoHallServerNotify.ILoginRsp>(NetMsgDataMapHallNotify.Login, function (protoData) {
            self.startCheckPing()
            if(self.onNotifyLogin){
                self.onNotifyLogin(protoData,self.isReconnect)   
            }
        }, true)

        self.model.subscibeMsgEvent<ProtoHallServerNotify.IEnterGameHallRsp>(NetMsgDataMapHallNotify.EnterGameHall, function (protoData) {
            if (self.onEnterGameHall) {
                self.onEnterGameHall(protoData)
            }
        }, true)

        self.model.subscibeMsgEvent<ProtoHallServerNotify.INotifyHallData>(NetMsgDataMapHallNotify.NotifyHallData, function (protoData) {
            if (self.onNotifyHallData) {
                self.onNotifyHallData(protoData)
            }
        }, true)

        let data: ProtoHallServerNotify.ILoginReq = {
            account: ModelData.instance.roleData.id + "",
            token: ModelData.instance.password + "",
            gameId: AppData.gameName
        }
        this.model.sendMsg(NetMsgDataMapHallNotify.Login, data);

        self.model.subscibeMsgEvent<ProtoHallServerNotify.INotifyRoomTypeData>(NetMsgDataMapHallNotify.NotifyRoomTypeData,function(protoData)
        {
            if(self.onNotifyRoomTypeData)
            {
                self.onNotifyRoomTypeData(protoData)
            }
        },true)
    }

    protected _requestPing() {
        if (this.netClient.netState) {
            let data: ProtoHallServerNotify.IPingReq = {
            }
            this.model.sendMsg(NetMsgDataMapHallNotify.Ping, data);
        }
    }

    protected onReconnectServer() {
        ModuleManager.instance.showModule(NetPrompt, { "showImmediately": true, "reconnect": true })
    }


    onReconnectServerFail() {
        
    }

    exit() {
        this.close()
        this.onNotifyLogin = null
        this.onNotifyPing = null
        this.onEnterGameHall = null
        this.onNotifyHallData = null
    }

}
